<template>
  <div>
    <ad></ad>
    <div class="content">
      <inner-nav :innerData="navList[4]" :innerTitle="navList[4].navChildList[0].name" :innerLink="navList[4].navChildList[0].toLink"></inner-nav>
      <div class="course-content">
        <div class="course-title">
          <h1>创业起步 夯实基础</h1>
          <h3>2015 — 2018</h3>
        </div>
        <div class="course-detail">
          <div class="swiper-course">
            <div class="swiper-course-swiper-p">
              <div class="swiper-course-swiper">
                <swiper v-if="listGrowns.length>1" :options="swiperOption">
                    <swiper-slide v-for="(item,index) in [...listGrowns,...listGrowns]" :key="index">
                      <div class="course-item">
                        <div class="item-year">{{item.year}} <span>year</span></div>
                        <div class="item-msg">
                          <img :src="'../../../static/img/coms_'+index%4+'.png'" alt="">
                          <div :class="setClass(index)">
                            <div>{{item.content}}</div>
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                </swiper>
                <!--以下看需要添加-->
                <div class="swiper-button-prev">
                  <div class="button-prev">
                    <img src="../../../static/img/prev.png" alt="">
                  </div>
                </div>
                <div class="swiper-button-next">
                  <div class="button-next">
                    <img src="../../../static/img/next.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ad_img">
            <img v-for="(item,index) in footerAdList" :key="index" :src="item.imgUrl" alt="">
          </div>

        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import ad from '../../components/advertisement'
  import InnerNav from '../../components/innerNav'
  export default {
    name: "",
    data(){
      return {
        listGrowns:[],
        footerAdList:[],
        //设置属性
        swiperOption:{
//          //显示分页
//          pagination: {
//            el: '.swiper-pagination',
//            clickable:true
//          },
          //切换模式  横屏或者竖屏
          // direction : 'vertical',
          //设置自动播放速度
//          autoplay: {
//            disableOnInteraction: false,
//            delay:4000
//          },
          //开启无限循环
          loop:true,
          //设置点击箭头
          paginationClickable :true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
//          prevButton:'.swiper-button-prev',
//          nextButton:'.swiper-button-next',低版本写法 高版本不可用
          //设置同屏显示的数量，默认为1，使用auto是随意的意思。
          slidesPerView:4,
          slidesPerGroup:1,
          //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，或true使用默认值。
        }
      }
    },
    components: {
      ad,
      InnerNav
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    created(){
      this.$http.get(`/outer/image/listImages.do`, {
        functionCode:3
      }).then((res)=>{
          this.footerAdList=res.data
      })
      this.$http.get(`/outer/development/listGrowns.do`).then((res)=>{
          this.listGrowns=res.data
      })
    },
    methods:{
      // 将class赋值给方法，动态生成对象
      setClass (index) {
        return 'item-msg-'+index%4;
      }

    }
  }
</script>

<style scoped lang="less">
  .course-content{
    padding-bottom: .6rem;
    padding-top:.3rem;
    width:12rem;
      .course-title{
        padding-bottom:.3rem;
          h1{
            font-size:.24rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.48rem;
          }
          h3{
            font-size:.14rem;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:.14rem;
          }
      }
      .ad_img{
        margin-top:1rem;
        img{
          height:2rem;
          width: 5rem;
        }
        img:nth-child(2){
          width:6.8rem;
          margin-left:.2rem;
        }
      }


  }



</style>
<style lang="less">
  .swiper-course{
    position: relative;
    margin: 0 auto;
    margin-top:.5rem;
      .swiper-slide{
        /*height:2rem;*/
        .course-item{
          .item-year{
            width:100%;
            font-size:.28rem;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:.6rem;
            font-family:PingFangSC-Medium;
            >span{
              font-size:.14rem;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height:.1rem;
            }
          }
          .item-msg{
            border-top:1px solid #999;
            clear: both;
            overflow:hidden;
            img{
              width:.25rem;
              float: left;
            }
            >div{
              font-size:.14rem;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:rgba(102,102,102,1);
              line-height:.22rem;
              float: left;
              width:90%;
              text-align: justify;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              padding:.3rem .2rem 0 ;
            }
          }
          .item-msg-0{
            div{
              overflow: hidden;
              text-overflow:ellipsis;
              display:-webkit-box;
              -webkit-line-clamp:10;
              -webkit-box-orient:vertical;
              max-height: 2.2rem;

            }
          }
          .item-msg-1{
            div{
              overflow: hidden;
              text-overflow:ellipsis;
              display:-webkit-box;
              -webkit-line-clamp:8;
              -webkit-box-orient:vertical;
              max-height: 1.76rem;

            }
          }
          .item-msg-2{
            div{
              overflow: hidden;
              text-overflow:ellipsis;
              display:-webkit-box;
              -webkit-line-clamp:5;
              -webkit-box-orient:vertical;
              max-height: 1.1rem;

            }
          }
          .item-msg-3{
            div{
              overflow: hidden;
              text-overflow:ellipsis;
              display:-webkit-box;
              -webkit-line-clamp:8;
              -webkit-box-orient:vertical;
              max-height: 1.76rem;
            }
          }
        }
      }

      .swiper-button-next,.swiper-button-prev{
        opacity:0;
        height:.7rem;
        width:.7rem;
        outline: none;
        background-image: none;
        -webkit-border-radius:50%;
        -moz-border-radius:50%;
        border-radius:50%;
        border:1px solid #999999;
      }
      .swiper-button-next{
        transition: right 1s ease;
        -webkit-transition: right 1s ease;/* Safari */
        right:-0.6rem;
          .button-next{
            margin: 0 auto;
            margin-top:.1rem;
            width:.5rem;
            height:.5rem;
              img{
                width:100%;
                height:100%
              }
          }
      }
      .swiper-button-prev{
        transition: left 1s ease;
        -webkit-transition: left 1s ease;/* Safari */
        left:-0.6rem;
          .button-prev{
            margin: 0 auto;
            margin-top:.1rem;
            width:.5rem;
            height:.5rem;
              img{
                width:100%;
                height:100%
              }
          }
      }

  }

  .swiper-course-swiper-p{
    width:14.4rem;
    margin-left:-1.2rem;
    .swiper-course-swiper{
      width:12rem;
      margin: 0 auto;
    }
  }
  .swiper-course-swiper-p:hover{
    .swiper-button-next{
      opacity: 1;
      right:-1.2rem;
    }
    .swiper-button-prev{
      opacity:1;
      left:-1.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/development/course.vue